"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const expandable_card_container_1 = __importDefault(require("../ExpandableCardContainer/expandable-card-container"));
const messages_1 = __importDefault(require("../../lib/messages"));
const provider_about_styles_1 = require("./provider-about.styles");
const about_content_1 = __importDefault(require("./about-content"));
const utils_1 = require("../../lib/utils");
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const ProviderAbout = ({ intl, config, provider, track }) => {
    /*
      Only provider fields that
        - are configured in config.provider_v9.summary_data
        - are not blacklisted in ABOUT_SECTION_EXCLUDE_SUMMARY_DATA_FIELDS
        - have data on the provider object
      are to be rendered here.
      */
    const aboutSectionSummaryData = (0, utils_1.getAboutSectionSummaryData)(config, provider);
    const providerName = provider.name.full;
    const degrees = (provider.degrees || [])
        .map(({ name }) => name)
        .join(', ');
    return (react_1.default.createElement(expandable_card_container_1.default, { id: "profile-about-section", track: track },
        react_1.default.createElement(provider_about_styles_1.AboutHeader, null, intl.formatMessage(messages_1.default.profileAboutHeader, {
            providerName,
            degrees
        })),
        aboutSectionSummaryData.map((fieldConfig) => {
            const { field, field_type, subfield } = fieldConfig;
            const content = (0, utils_1.extractProviderDataContent)(fieldConfig, provider);
            if (content == null) {
                return null;
            }
            // fields only display titles if there is a config.application_string_template defined for it
            // NOTE: titles are only intl'd if we remember to add messages for them
            const applicationStringTemplates = config.application_string_templates || {};
            const fieldPath = subfield ? `${field}.${subfield}` : field;
            const shouldDisplayTitle = Boolean(applicationStringTemplates[`field.name.${fieldPath}`]);
            const message = messages_1.default[`profileAbout_${String(fieldPath)}`];
            const title = message
                ? intl.formatMessage(message)
                : applicationStringTemplates[`field.name.${fieldPath}`];
            const logoConfigs = (config.logos_v9 || []).filter((logoConfig) => logoConfig.field === field);
            return (react_1.default.createElement(about_content_1.default, { key: fieldPath, title: shouldDisplayTitle ? title : undefined, richText: field_type === 'rich_text', content: content.toString(), logoConfigs: logoConfigs, provider: provider, dataTestId: `profile-about-${fieldPath}` }));
        })));
};
exports.default = (0, with_error_boundary_1.withErrorBoundary)((0, intl_1.injectIntl)(ProviderAbout));
//# sourceMappingURL=provider-about.js.map